import ShipmentCustomersSearch from "./ShipmentCustomersSearch";

export default function ShipmentCusSidebarLayout({
  activeFilter,
  setActiveFilter,
  navItems,
  cusQuery,
  setCusQuery,

  // handleSearch,
  setSelectedCustomer,
  selectedCustomer,
  showCusAdvanceForm,
  setShowCusAdvanceForm,
  customersList,
  totalCustomers,

  // Advance Form Props
  filterTabCounts,
  isAdvanceMode,
  setIsAdvanceMode,
  resetRequestList,
}) {
  /*   All States
   ********************************************* */
  const sidebarWidth = 300;
  const sidebarStyle = {
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    borderRadius: "8px",
    background: "#fff",
    transition: "width 0.3s",
    width: sidebarWidth,
    padding: "24px 16px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  };

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  return (
    <div style={sidebarStyle}>
      {/* Tabs */}

      <div className="h-100">
        <ShipmentCustomersSearch
          navItems={navItems}
          setSelectedCustomer={setSelectedCustomer}
          selectedCustomer={selectedCustomer}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          cusQuery={cusQuery}
          setCusQuery={setCusQuery}
          showCusAdvanceForm={showCusAdvanceForm}
          setShowCusAdvanceForm={setShowCusAdvanceForm}
          customersList={customersList}
          totalCustomers={totalCustomers}
          filterTabCounts={filterTabCounts}
          isAdvanceMode={isAdvanceMode}
          setIsAdvanceMode={setIsAdvanceMode}
          resetRequestList={resetRequestList}
        />
      </div>
    </div>
  );
}
